import { Alert } from '@mui/material'
import { useEffect, useState } from 'preact/hooks'

/** Offline, the service worker serves the last loaded data and changes fail. */
export function OfflineNotice() {
  const [online, setOnline] = useState(navigator.onLine)
  useEffect(() => {
    const update = () => setOnline(navigator.onLine)
    window.addEventListener('online', update)
    window.addEventListener('offline', update)
    return () => {
      window.removeEventListener('online', update)
      window.removeEventListener('offline', update)
    }
  }, [])
  if (online) return null
  return (
    <Alert
      severity="info"
      square
      sx={{ displayPrint: 'none', position: 'relative', zIndex: 'appBar' }}
    >
      Hors ligne : dernières données chargées, modifications impossibles.
    </Alert>
  )
}
